"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import { allowed, useConsent } from "@/components/consent/store";
import { isSensitiveSearch, SENSITIVE_PATH } from "@/lib/themes-shared";

const PRIVATE = /^\/(admin|login|setup|vorschau)(\/|$)/;

/**
 * Meldet Seitenaufrufe an /api/hit: ohne Cookies, ohne Speicher im Browser, nur an den eigenen Server.
 * Seiten geschützter Themenwelten (LGBT) nur mit Statistik-Einwilligung und ohne Herkunft (x: 1).
 */
export function StatsBeacon() {
  const pathname = usePathname();
  const consent = useConsent();
  const statsOk = allowed(consent, "statistics");
  const last = useRef("");

  useEffect(() => {
    if (!pathname || PRIVATE.test(pathname)) return;
    const params = new URLSearchParams(location.search);
    const key = `${pathname}?${params.get("q") ?? ""}`;
    // Doppelte Effekte (Entwicklungsmodus, erneutes Rendern) nicht doppelt zählen.
    if (last.current === key) return;
    const sensitive = SENSITIVE_PATH.test(pathname) || !!document.querySelector("[data-sensitive]");
    if (sensitive && !statsOk) return;
    // document.referrer bleibt bei Navigation innerhalb der Seite stehen: nur beim ersten Aufruf mitsenden.
    const ref = last.current ? "" : document.referrer;
    last.current = key;
    const q = pathname === "/suche" ? params.get("q") ?? "" : "";
    const body = JSON.stringify({
      p: pathname,
      r: sensitive ? "" : ref,
      s: sensitive ? "" : params.get("utm_source") ?? "",
      q: isSensitiveSearch(q) ? "" : q,
      w: innerWidth,
      x: sensitive ? 1 : 0,
    });
    const blob = new Blob([body], { type: "text/plain" });
    if (!navigator.sendBeacon?.("/api/hit", blob)) {
      fetch("/api/hit", { method: "POST", body, keepalive: true, headers: { "content-type": "text/plain" } }).catch(() => {});
    }
  }, [pathname, statsOk]);

  return null;
}
